/**
 * FX-PORT wave 1 batch A: กระบี่ลมโชย (breeze-sword) in the sample style — ลมโชยปลายกระบี่, ลมโชยพาดผ่าน,
 * ลมหายใจไผ่เขียว, หมอกลมคลุมกาย, ต้นอ้อลู่ลม, พายุลมโชย (render/fx/sampleArt/arts/breeze.ts). Every port is off until
 * main's review (the per-spec `on` flag); review page tools/fxSamples/arts/sword.html.
 */
import { BREEZE_FX } from './sampleArt/arts/breeze';
import { portArt } from './sampleArt/families/swordKit';

portArt(BREEZE_FX);
